module.exports = "/images/a802e4f13f60f8e71680bf046538de90.svg";